//natives
import React from 'react';
import {CircularProgress} from "@material-ui/core";

//components
import Table from "../../../../../../../../../util/Table/.mixins/Table";
import Alerta from "../../../../../../../../../util/snackbars/.mixins/";

//css
import useStyles from './styles';

export default (props) => {
    const classes = useStyles();
    return(
        <>
            {props.state.isLoading &&
                <div align="center">
                    <CircularProgress />
                </div>
            }
            {!props.state.isLoading && !props.state.isError &&
                <>
                    <Table {...props} className={classes.root}/>
                    <Alerta ref={props.child}/>
                </>
            }
            {props.state.isError &&
                <div align="center">
                    <Error text={props.state.error}/>
                </div>
            }
        </>
   );
};